// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-create-browse{border-left:1px solid var(--color-table-border-base);display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
